import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import TiposProductoQuejaTable from './_TiposProductoQuejaTable.js';
import EditTipoProductoQueja from './_EditTipoProductoQueja.js';
const URI = ApiEndpoint + 'configuration/';

const TiposProductoQueja = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();

  const [tiposProducto, setTiposProducto] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  // const [openConfirm, setOpenConfirm] = useState(false);
  const [idTipoProductoEdit, setIdTipoProductoEdit] = useState(null);
  // const handleCloseConfirm = () => {
  //   setOpenConfirm(false);
  //   getTiposProducto();
  // };
  const handleClose = () => {
    setOpenModal(false);
    getTiposProducto();
  };

  const getTiposProducto = async () => {
    setTiposProducto(null);

    httpClient('GET', URI + 'tiposproducto', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setTiposProducto(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getTiposProducto();
  }, []);

  return (
    <>
      {tiposProducto && (
        <TiposProductoQuejaTable
          tiposproducto={tiposProducto}
          setOpenModal={setOpenModal}
          setOpenConfirm={() => {}}
          setIdTipoProducto={setIdTipoProductoEdit}
        ></TiposProductoQuejaTable>
      )}
      {/* {openConfirm && (
        <ConfirmAction
          message={'Desea eliminar el registro?'}
          title={'Confirmacion'}
          handleClose={handleCloseConfirm}
          open={openConfirm}
          ConfirmAction={DeleteConfirmed}
        ></ConfirmAction>
      )} */}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idTipoProductoEdit > 0 ? 'Editar' : 'Agregar') +
            ' Tipo de Producto'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditTipoProductoQueja
            idTipoProducto={idTipoProductoEdit}
            closeModal={handleClose}
          />
        </MyModal>
      )}
    </>
  );
};

export default TiposProductoQueja;
